
import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {FormBuilder, FormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import {AuthService} from "../../../services/auth.service";
import {CoreService} from "../../../services/core.service";
import {ConfirmedValidator, GetCurrentUser, HandleResponseError} from "../../../shared/functions/shared-functions";
import {PageTitleService} from "../../../core/components/page-title/page-title.service";
import {fadeInUp400ms} from "../../../../@config/animations/fade-in-up.animation";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  animations: [fadeInUp400ms],
  encapsulation: ViewEncapsulation.None,
})
export class ChangePasswordComponent implements OnInit {
  mainLogo = environment.mainLogo;
  form: FormGroup;

  newInputType = 'password';
  confirmInputType = 'password';
  confirmVisible = false;
  newPassVisible = false;
  constructor(public authService: AuthService,
              private toastr: ToastrService,
              public translate: TranslateService,
              public router: Router,
              private coreService: CoreService,
              private fb: UntypedFormBuilder,
              private cd: ChangeDetectorRef,
              public pageTitleService: PageTitleService,
              private translateService: TranslateService
  ) {
  }


  ngOnInit(): void {
    this.form = this.fb.group({
        newPass: ['', [Validators.required]],
        confirmPassword: ['', [Validators.required]]
      },
      {validators: [ConfirmedValidator('newPass', 'confirmPassword')]});
  }

  send(value) {
    // console.log('value', value);
    const body = {
      password: this.form.value.newPass,
      password_confirmation: this.form.value.confirmPassword,
    }
    // // console.log(body)
    this.coreService.postRequest('admin/change-password', body).subscribe(
      res => {
        // // console.log('')res', res);
        this.form.reset();
        this.translateService.get('Password changed Successfully!').subscribe(word => {
          this.toastr.success(word);
        })
      }, error => {
        // // console.log('')err', error)
        this.toastr.error(HandleResponseError(error));
      }
    )
  }

  toggleVisibility(type) {
    if (type === 'new') {
      if (this.newPassVisible) {
        this.newInputType = 'password';
        this.newPassVisible = false;
        this.cd.markForCheck();
      } else {
        this.newInputType = 'text';
        this.newPassVisible = true;
        this.cd.markForCheck();
      }
    } else {
      if (this.confirmVisible) {
        this.confirmInputType = 'password';
        this.confirmVisible = false;
        this.cd.markForCheck();
      } else {
        this.confirmInputType = 'text';
        this.confirmVisible = true;
        this.cd.markForCheck();
      }
    }
  }
}
